import React from 'react';
import { Link } from 'react-router-dom';

function QRCode() {
  return (
    <div className="min-h-screen flex flex-col bg-emerald-600">
      {/* Header */}
      <header className="w-full px-4 py-4 pt-16 flex justify-between items-center">
        <div className="container mx-auto flex justify-between items-center">
          <img
            src="/images/logo_full.svg"
            alt="WearTwice Logo"
            width="179"
            height="72"
            className="md:ml-4"
          />
          <Link to="/" className="text-white text-3xl">
            ×
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex flex-col items-center justify-center text-white text-center px-4">
        <h1 className="text-2xl mb-4">
          Visit https://weartwice.com on your phone
          <br />
          or scan the following QR code
        </h1>

        <div className="bg-white w-48 h-48 mb-8 flex items-center justify-center">
          <img
            src="/images/home_qr_code.svg"
            alt="QR Code"
            width="200"
            height="200"
          />
        </div>

        <div className="flex space-x-4">
          <a target="_blank" rel="noreferrer" className="w-40 sm:w-40" href="https://apps.apple.com/us/app/weartwice/id6733228175">
            <img
                src="/images/app-store-badge.svg"
                alt="App Store"
                width="135"
                height="40"
            />
          </a>
          <a target="_blank" rel="noreferrer" className="w-40 sm:w-40" href="https://play.google.com/store/apps/details?id=com.weartwice.weartwice">
            <img
                src="/images/google-play-badge.svg"
                alt="Google Play"
                width="135"
                height="40"
            />
          </a>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black text-green-800 mx-auto text-center py-12 space-y-12 w-full">
        <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 text-sm md:text-base">
          <li><a className="hover:underline text-white font-bold" href="/shipping-policy">Shipping policy</a></li>
          <li><a className="hover:underline text-white font-bold" href="/users-terms-conditions">Users terms and conditions</a></li>
          <li><a className="hover:underline text-white font-bold" href="/acceptable-use-policy">Acceptable use policy</a></li>
          <li><a className="hover:underline text-white font-bold" href="/privacy-policy">Privacy Policy</a></li>
        </ul>
        <div className="mt-6">
          <img alt="Weartwice Logo" loading="lazy" width="200" height="50" className="mx-auto" src="/images/logo_full.svg" />
        </div>
        <div className="mt-6 text-xs md:text-sm text-white">© 2024 Weartwice. All rights reserved.</div>
      </footer>
    </div>
  );
}

export default QRCode;
